// AUTH_18 (#323): a donde vuelve la persona despues de ingresar.
// Quien abre la documentacion de la API (/docs) sin sesion pasa por el login y vuelve a
// /docs-access. El destino es un valor fijo, nunca una direccion que llega de afuera: el login
// no puede llevar a ninguna otra parte. Vive en sessionStorage para sobrevivir al ida y
// vuelta del SSO y a las pantallas del 2FA; se borra al usarlo y al cerrar sesion.

const KEY = 'aldo:post-login'
const API_DOCS = 'api-docs'

// (no empieza con /api: el servidor de desarrollo de Vite reenvia /api* a otro servicio)
export const API_DOCS_GATE_PATH = '/docs-access'

function read(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function rememberApiDocsReturn(): void {
  try {
    sessionStorage.setItem(KEY, API_DOCS)
  } catch {
    // Sin sessionStorage la persona vuelve al inicio, como siempre
  }
}

export function clearPostLoginReturn(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // nada que borrar
  }
}

/** Pantalla a la que va la persona al terminar de ingresar. */
export function postLoginPath(): string {
  return read() === API_DOCS ? API_DOCS_GATE_PATH : '/home'
}
